import React, { useContext } from 'react';
import cn from 'classnames';
import ConfigContext from '../../../contexts/ConfigContext';

import styles from './WhyBookWithUs.module.postcss';

// Copy follows the voice bible (design/voice-bible-2026-09-v4.1.md §6 trust
// lines and §5 fee rules): no "no commission" or "no markup" claims, the
// pricing line is "See the full price, including fees, before you book."
function WhyBookWithUs({ title }) {
  const { site_title, logo, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const UsVsOthers = (
    <>
      <div className={cn(styles.WhyItem, styles.WhyItem__us)}><span className='icon icon-approved' /></div>
      <div className={cn(styles.WhyItem, styles.WhyItem__others)}><span className='icon icon-denied' /></div>
    </>
  );

  return (
    <section className='Section'>
      <div className={styles.WhyBook}>
        <h2 className='u-textCenter'>{ title || 'Why book with us' }</h2>
        <div className={styles.WhyGrid}>

          <div className={cn(styles.WhyItem, styles.WhyHeader, styles.WhyItem__desc)}/>
          <div className={cn(styles.WhyItem, styles.WhyHeader, styles.WhyItem__us)}>
            <img src={logo} alt={site_title} width='150' height='25' />
          </div>
          <div className={cn(styles.WhyItem, styles.WhyHeader, styles.WhyItem__others)}>
            Others
          </div>

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Free quotes</span>
            <span className='u-noMobile'><strong>Requesting quotes is free</strong> – You only pay when you book.</span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Message trucks directly</span>
            <span className='u-noMobile'><strong>Message {vehicleType}s directly</strong> – Talk to the {vehicleType}s you&#39;re considering, then book on the site.</span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Compare options</span>
            <span className='u-noMobile'><strong>Compare options before you book</strong> – See menus, pricing, and availability side by side.</span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Every cuisine</span>
            <span className='u-noMobile'><strong>More than one cuisine</strong> – Tacos, BBQ, pizza, burgers, desserts, coffee, and plenty more.</span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Full price up front</span>
            <span className='u-noMobile'><strong>See the full price, including fees, before you book</strong></span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyItem__desc)}>
            <span className='u-mobileOnly'>Details stay editable</span>
            <span className='u-noMobile'><strong>Keep event details editable</strong> – Change the date, guest count, or budget while you compare options.</span>
          </div>
          { UsVsOthers }

          <div className={cn(styles.WhyItem, styles.WhyHeader)}/>
          <div className={cn(styles.WhyItem, styles.WhyHeader, styles.WhyItem__us)}/>
          <div className={cn(styles.WhyItem, styles.WhyHeader)}/>

        </div>
      </div>
    </section>
  );
}

export default WhyBookWithUs;
